/* eslint-disable indent */
/* eslint-disable no-console */
/* eslint-disable func-names */
import React, { useState, useRef, useEffect } from 'react';
import MobileStepper from '@material-ui/core/MobileStepper';
import Button from '@material-ui/core/Button';
import { Link } from 'react-router-dom';
import CameraIcon from '@material-ui/icons/PhotoCamera';
import CheckIcon from '@material-ui/icons/Check';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import IconButton from '@material-ui/core/IconButton';
import Dialog from '@material-ui/core/Dialog';
import CloseIcon from '@material-ui/icons/Close';
import 'react-html5-camera-photo/build/css/index.css';
import { isCreditCard } from 'validator';
import MaskedInput from 'react-text-mask';
import PropTypes from 'prop-types';
import Axios from 'axios';
import { get, isEmpty, filter, toLower, includes, head, find } from 'lodash';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import Numeral from 'numeral';
import parse from 'html-react-parser';
import 'moment/locale/es';
import { Buffer } from 'buffer';
import LogRocket from 'logrocket';
import { isIOS } from 'mobile-device-detect';

import { useMediaQuery } from '@material-ui/core';
import { createUrlForSrc, media } from '../../utils/helper';
import Loader from '../../components/Loader';

import config from '../../config';

import {
  Content,
  ContainerCard,
  NavBarContainer,
  ContainerGeneral,
  ContentButonGroup,
  ContentButon,
  ContentDialog,
  ContainerData,
  ButtonGrupDialog,
  ContentTerms,
  ContainerDialogTerms,
  ImageContainer,
  DocumentContainer,
  ImageDocumentContainer,
  DistributorImage,
  DocumentText,
} from './styledComponents';
window.Buffer = window.Buffer || Buffer;

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const options = {
  // eslint-disable-next-line consistent-return
  replace: domNode => {
    if (domNode.attribs && domNode.attribs.class === 'remove') {
      return <></>;
    }
  },
};

const TextMaskCustom = props => {
  const { inputRef, placeholder, ...other } = props;

  return (
    <MaskedInput
      {...other}
      ref={ref => {
        inputRef(ref ? ref.inputElement : null);
      }}
      mask={[
        /[4-5]/,
        /\d/,
        /\d/,
        /\d/,
        ' ',
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        ' ',
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        ' ',
        /\d/,
        /\d/,
        /\d/,
        /\d/,
      ]}
      placeholderChar={'\u2000'}
      placeholder={placeholder}
    />
  );
};

TextMaskCustom.propTypes = {
  inputRef: PropTypes.any.isRequired,
  placeholder: PropTypes.string.isRequired,
};

function urltoFile(url, filename, mimeType) {
  return fetch(url)
    .then(function(res) {
      return res.arrayBuffer();
    })
    .then(function(buf) {
      return new File([buf], filename, { type: mimeType });
    });
}

const CanjePrestamoConfirmar = props => {
  const [activeStep, setActiveStep] = React.useState(0);

  const [cancelVaucher, setCancelVaucher] = useState(false);

  const [termsAgreed, setTermsAgreed] = useState(false);
  const [termsAndConditions, setTermsAndConditions] = useState('');
  const [identityValidationAttempts, setIdentityValidationAttempts] = useState(
    0,
  );
  const [validationAttempt, setValidationAttempt] = useState('');
  const [errorSelfie, setErrorSelfie] = useState('');
  const [termsAgreedOpen, setTermsAgreedOpen] = useState(false);

  const [fileUploaded, setFileUploaded] = useState(null);

  const [editCard, setEditCard] = useState(false);
  const [cardTouched, setCardTouched] = useState(false);
  const [card, setCard] = useState('');

  const [notFound, setNotFound] = useState('');
  const [loading, setLoading] = useState(true);
  const [confirmCardTouched, setConfirmCardTouched] = useState(false);
  const [confirmCard, setConfirmCard] = useState('');

  const [errorText, setErrorText] = useState('');
  const [inputsDisabled, setInputsDisabled] = useState(false);
  const [banksOptions, setBanksOptions] = useState([]);

  const token = get(props, 'match.params.token', '');
  const [alreadyUsed, setAlreadyUsed] = useState('');
  const [lastDigits, setLastDigits] = useState('');
  const [bank, setBank] = useState('');
  const [newBank, setNewBank] = useState('');

  const [clientInfo, setClientInfo] = useState(null);
  const [loadingFull, setLoadingFull] = useState(false);
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const [successText, setSuccessText] = useState('');
  const [valeCanjeado, setValeCanjeado] = useState('');

  const [showIdentityValidator, setShowIndentityValidator] = useState(true);
  // const [showVideoCapturer, setShowVideoCapturer] = useState(false);

  const [voucherRedeemed, setVaucherRedeemed] = useState(false);

  const [startExchange, setStartExchange] = useState(false);
  const [editAddress, setEditAddress] = useState(false);
  const [existAddress, setExistAddress] = useState(false);
  const [existCard, setExistCard] = useState(null);

  const [myBankName, setMyBankName] = useState('');

  const [confirmCancelVaucher, setConfirmCancelVaucher] = useState(false);

  const [seguroOptions, setSeguroOptions] = useState([]);
  const [seguroSelected, setSeguroSelected] = useState(null);

  const [ineFrente, setIneFrente] = useState('');
  const [ineReverso, setIneReverso] = useState('');
  const [alreadyIdCapture, setAlreadyIdCapture] = useState(true);
  const [alreadyIdCaptureError, setAlreadyIdCaptureError] = useState(false);
  const [selfie, setSelfie] = useState(null);
  const [alreadyFaceCapture, setAlreadyFaceCapture] = useState(false);
  const [errorFaceCapture, setErrorFaceCapture] = useState(false);
  const [tokenNubarium, setTokenNubarium] = useState();
  const [currentlyFaceCapture, setCurrentlyFaceCapture] = useState(false);
  const [currentlyIdCapture, setCurrentlyIdCapture] = useState(false);
  const [successSelfie, setSuccessSelfie] = useState('');

  const [ineFront, setIneFront] = useState(null);
  const [ineBack, setIneBack] = useState(null);
  const [ineFrontUrl, setIneFrontUrl] = useState(null);
  const [ineBackUrl, setIneBackUrl] = useState(null);

  const isMobile = useMediaQuery(media.medium);

  const [parametros, setParametros] = useState(null);
  const [prestamo, setPrestamo] = useState({});
  const [distribuidora, setDistribuidora] = useState({});
  const [prospecto, setProspecto] = useState({});
  const [tarjetaDebito, setTarjetaDebito] = useState({});
  const [requiereIdentificacion, setRequiereIdentificacion] = useState(false);
  const [totalSteps, setTotalSteps] = useState(2);
  const [passNextStep, setPassNextStep] = useState(false);

  // Geolocation
  // eslint-disable-next-line prefer-const
  let latitudRef = useRef(null);
  // eslint-disable-next-line prefer-const
  let longitudRef = useRef(null);

  /**
   * @param {string} stringBase64 String Base64 de la Imagen
   * @param {string} fileName Nombre del Archivo
   * @returns {Promise<File>}
   */
  const compressImage = async (stringBase64, fileName) => {
    const img = new Image();
    img.src = `data:image/png;base64,${stringBase64}`;

    await new Promise((resolve, reject) => {
      img.onload = resolve;
      img.onerror = error =>
        reject(new Error(`Failed to load image: ${error.message}`));
    });

    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');

    // Set canvas dimensions to the original image's resolution
    canvas.width = img.naturalWidth;
    canvas.height = img.naturalHeight;

    // Draw the image onto the canvas
    ctx.drawImage(img, 0, 0);

    // Compress the image to JPEG with a lower quality (e.g., 0.7 for 70% quality)
    const desiredQuality = 0.7; // Adjust this value for more or less compression
    const outputMimeType = 'image/jpeg'; // JPEG is good for lossy compression

    // Wait for the blob to be created
    const blob = await new Promise(resolve => {
      canvas.toBlob(resolve, outputMimeType, desiredQuality);
    });

    if (!blob) {
      throw new Error('Failed to compress image: Blob creation failed.');
    }

    // Create a new File object from the compressed blob
    const compressedSelfieFile = new File([blob], `${fileName}.jpeg`, {
      type: outputMimeType,
      lastModified: Date.now(),
    });

    return compressedSelfieFile;
  };

  const IdComponent = () => {
    if (alreadyIdCapture) return <div />;
    try {
      // eslint-disable-next-line no-undef
      const idCapture = new IdCapture();

      // Initialize the component with your custom configuration
      const idCaptureConfig = {
        rootElement: 'id_component', // DOM Element that will contains the HTML Component
        maxValidations: 99,
        timeouts: {
          front: 180000,
          back: 180000,
        },
        captureMode: {
          front: {
            enabled: true,
            after: 0,
          },
          back: {
            enabled: true,
            after: 0,
          },
        },
        // Enable/Disable image guide
        guide: {
          front: {
            enabled: true, // Enable guide on front capture. (By default is enabled)
          },
          back: {
            enabled: true, // Enable guide on back capture. (By default is enabled)
            until: 10000,
          },
        },
        autorotate: true, // Automatic rotate the image to return a landscape image.
        antispoofing: {
          // Default values
          enabled: true,
          level: 10,
        },
      };

      // Set the JWT token
      // faceCapture.setToken(
      idCapture.setToken(tokenNubarium);
      // eslint-disable-next-line no-undef

      // faceCapture.init(nubariumConfig);
      idCapture.init(idCaptureConfig);

      idCapture.load(() => {
        // Once that the component is loaded then it will execute the following
        // If you requires to start the component automatically after load its recommend it to start the component.
        idCapture.start();
      });

      idCapture.onEvaluation((evaluation, result) => {
        const ev = evaluation; // success, fail
        // The result object is similar to the onSuccess or onFail.
      });
      idCapture
        .onSuccess(data => {
          setIneFrente(data.front);
          setIneReverso(data.back);
          setAlreadyIdCapture(true);
          setAlreadyIdCaptureError(false);

          setCurrentlyIdCapture(false);
          console.log('onSuccess', data);
          try {
            idCapture.clear();
            idCapture.close();
          } catch (e) {
            console.log(`Error from Nubarium: ${e}`);
          }
          // delete idCapture.instance;
        })
        .onFail(fail => {
          console.log('onFail', fail);
          // idCapture.retry();
          setAlreadyIdCaptureError(true);
          // NOTE: No sirve pero es lo mas cercano a que
          // funcione
          setTimeout(() => {
            // idCapture.close();
            // idCapture.retry();
            // idCapture.reset();
          }, 100);
        })
        .onError(error => {
          console.log('onError', error);
          const errorCode = error.code;
          const errorMsg = error.msg;
        });
    } catch (e) {
      console.log(e);
      return <div></div>;
    }

    // eslint-disable-next-line consistent-return
    return <div></div>;
  };

  const FaceComponent = () => {
    // eslint-disable-next-line no-undef
    const faceCapture = new FaceCapture();

    // Initialize the component with your custom configuration
    const faceCaptureConfig = {
      rootElement: 'face_component', // DOM Element that will contains the HTML Component
      maxValidations: 3,
      features: {
        // Optional
        disabled: ['glasses', 'facemask'], // Default values // Does not allow glasses and facemask
        enabled: [],
      },
      antispoofing: {
        // Default values
        enabled: true,
        level: 3,
      },
    };

    // Set the JWT token
    // faceCapture.setToken(
    faceCapture.setToken(tokenNubarium);
    // eslint-disable-next-line no-undef

    // faceCapture.init(nubariumConfig);
    faceCapture.init(faceCaptureConfig);

    faceCapture.load(() => {
      // Once that the component is loaded then it will execute the following
      // If you requires to start the component automatically after load its recommend it to start the component.
      faceCapture.start();
    });

    faceCapture.onEvaluation((evaluation, result) => {
      const ev = evaluation; // success, fail
      // The result object is similar to the onSuccess or onFail.
    });
    faceCapture
      .onSuccess(data => {
        console.log('onSuccess', data);
        setAlreadyFaceCapture(true);
        setCurrentlyFaceCapture(false);
        setSelfie(data.frame);
      })
      .onFail(fail => {
        console.log('onFail', fail);
        setTimeout(() => {
          faceCapture.retry();
          // idCapture.close();
          // idCapture.retry();
          // idCapture.reset();
        }, 100);
      })
      .onError(error => {
        console.log('onError', error);
        const errorCode = error.code;
        const errorMsg = error.msg;
      });

    return <div />;
  };

  const searchFilterFunction = () => {
    const newData = filter(banksOptions, item =>
      includes(toLower(item.id), toLower(bank)),
    );
    const data = get(newData[0], 'nombre');
    setMyBankName(data);
  };

  useEffect(() => {
    searchFilterFunction();
  }, [searchFilterFunction]);

  useEffect(() => {
    if (fileUploaded) {
      handleValidateSelfie();
    }
  }, [fileUploaded]);

  useEffect(() => {
    if (selfie) {
      handleValidateSelfie();
    }
  }, [selfie]);

  const handleOpenCancelVaocuher = () => {
    setCancelVaucher(true);
  };

  const handleCloseCancelVaucher = () => {
    setCancelVaucher(false);
  };

  const handleCancelVaucher = async () => {
    try {
      setLoading(true);
      await Axios.post(
        `${config.api.url}/prestamosPersonales/cancelar-prestamo-pendiente`,
        { tokenPrestamo: token },
      );

      setCancelVaucher(false);
      setConfirmCancelVaucher(true);
    } finally {
      setLoading(false);
    }
  };

  const start = () => {
    setStartExchange(true);
    navigator.geolocation.getCurrentPosition(success, xerror, xoptions);
  };

  const handleConfirmarPrestamo = async () => {
    let response;
    try {
      setLoadingFull(true);

      setButtonDisabled(true);

      const formData = new FormData();

      if (showIdentityValidator) {
        // const selfieBuffer = Buffer.from(selfie, 'base64');
        // const selfieFile = new File([selfieBuffer.buffer], 'selfie.png', {
        //   type: 'image/png',
        // });
        // console.log(selfieBuffer);
        let selfieFile;
        try {
          selfieFile = await compressImage(selfie, 'selfie');
        } catch (errorSelfieFile) {
          throw new Error('Error al momento de comprimir la imagen');
        }
        formData.set('selfie', selfieFile);
      }
      console.log('Se agrega el tokenPrestamo');
      formData.set('tokenPrestamo', token);

      // formData.set('latitud', latitud);
      // formData.set('longitud', longitud);
      console.log('Se agrega latitud');
      formData.set('latitud', latitudRef.current);
      console.log('Se agrega longitud');
      formData.set('longitud', longitudRef.current);

      console.log('Se realiza la request a confirmar-prestamo');
      response = await Axios.post(
        `${config.api.url}/prestamosPersonales/confirmar-prestamo`,
        formData,
        {
          'Content-Type': 'multipart/form-data',
        },
      );
      console.log('Se finaliza la request a confirmar-prestamo');

      const isError = get(response, 'data.output.payload.error', false);
      const isSuccess =
        get(response, 'data.success', false) || get(response, 'data', false);
      if (isError || !isSuccess) {
        setErrorText(
          get(
            response,
            'data.output.payload.message',
            'No se pudo validar la identidad de la distribuidora.',
          ),
        );
        setButtonDisabled(false);
        return;
      }

      setSuccessText('Prestamo confirmado con éxito.');
      setValeCanjeado(
        'El depósito de tu préstamo está en proceso, en breve recibirás tu dinero.',
      );
      setVaucherRedeemed(true);
    } catch (error) {
      console.log('error');
      console.log(error);
      console.log('response');
      console.log(response);
      setErrorText('Error canjeando préstamo');
      setButtonDisabled(false);
    } finally {
      setLoadingFull(false);
    }
  };

  useEffect(() => {
    fetchData();
    fetchConfig();
    LogRocket.init('wtmro9/conmigo-canje-prestamos');
  }, []);

  const uploadInes = async () => {
    try {
      setLoadingFull(true);

      const formData = new FormData();
      // TODO ARRAYBUFFER, READ FROM BASE64
      // NOTE: Original
      // const ineFrenteBuffer = Buffer.from(ineFrente, 'base64');
      // const ineFrenteFileOriginal = new File(
      //   [ineFrenteBuffer.buffer],
      //   'frenteIne.png',
      //   {
      //     type: 'image/png',
      //   },
      // );
      const ineFrenteFile = await compressImage(ineFrente, 'frenteIne');
      formData.append('files', ineFrenteFile);
      formData.append('token', token);
      formData.append('tipo', 'credencialElectorSuperior');

      await Axios.post(
        `${config.api.url}/prestamosPersonales/subirIdentificacionesDistribuidora`,
        formData,
      );

      const formData2 = new FormData();
      // Original
      // const ineReversoBuffer = Buffer.from(ineReverso, 'base64');
      // const ineReversoFile = new File(
      //   [ineReversoBuffer.buffer],
      //   'reversoIne.png',
      //   {
      //     type: 'image/png',
      //   },
      // );
      // const ineAtras = new File([ineReversoFile], 'backIne.png', {
      //   type: 'image/png',
      // });
      const ineReversoFile = await compressImage(ineReverso, 'reversoIne');

      formData2.append('files', ineReversoFile);
      formData2.append('token', token);
      formData2.append('tipo', 'credencialElectorInferior');

      await Axios.post(
        `${config.api.url}/prestamosPersonales/subirIdentificacionesDistribuidora`,
        formData2,
      );
    } catch (error) {
      console.error(error);
    } finally {
      setLoadingFull(false);
    }
  };

  // TODO: Mejorar esta funcion para que solo funcione con el estado correcto === 5
  const handleNext = async () => {
    if (activeStep === 1 && (ineFrente || ineReverso)) {
      await uploadInes();
    }
    if (activeStep === 2) {
      if (editCard || !isEmpty(ineFrente) || !isEmpty(ineReverso)) {
        setShowIndentityValidator(true);
      }
    }
    setActiveStep(prevActiveStep => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep(prevActiveStep => prevActiveStep - 1);
    setTermsAgreed(false);
    if (activeStep === 2) {
      setErrorSelfie(null);
      setFileUploaded(null);
      setErrorText(null);
    }
  };

  const handleTermsAgreedOpen = () => {
    setTermsAgreedOpen(true);
  };

  const handleTermsAgreedClose = () => {
    setTermsAgreedOpen(false);
  };

  const errorConfirmCard = confirmCardTouched && confirmCard !== card;

  // useEffect(() => {
  //   if (requiereIdentificacion) {
  //     // setTotalSteps(prevTotalSteps => prevTotalSteps + 1);
  //     setTotalSteps(totalSteps + 1);
  //   }
  // }, [requiereIdentificacion]);

  const handleValidateSelfie = async () => {
    try {
      setLoadingFull(true);

      const formData = new FormData();

      const selfieBuffer = Buffer.from(selfie, 'base64');
      const selfieFile = new File([selfieBuffer.buffer], 'selfie.png', {
        type: 'image/png',
      });

      formData.set('tokenPrestamo', token);
      // formData.set('distribuidoraId', distribuidora.id);
      formData.set('selfie', selfieFile);

      const response = await Axios.post(
        `${config.api.url}/prestamosPersonales/validar-distribuidora`,
        formData,
        {
          'Content-Type': 'multipart/form-data',
        },
      );

      const isError = get(response, 'data.output.payload.error', false);
      const isSuccess = get(response, 'data.success', false);
      if (isError || !isSuccess) {
        setErrorText(
          get(
            response,
            'data.output.payload.message',
            'No se pudo validar la identidad del cliente.',
          ),
        );
        setButtonDisabled(false);
        setErrorSelfie(
          get(
            response,
            'data.output.payload.message',
            'No se puedo validar la identidad del cliente.',
          ),
        );
        setShowIndentityValidator(true);
        setErrorFaceCapture(true);
      } else {
        setErrorText('');
        setButtonDisabled(false);
        setErrorSelfie(null);
        setErrorFaceCapture(false);
        setSuccessText('Identidad validada con éxito!');
        setSuccessSelfie('Identidad validada con éxito!');
      }
    } catch (error) {
      const errorRequest = JSON.parse(error.request.response);
      console.log(errorRequest.error.message);
      setErrorText(`${errorRequest.error.message}`);
      setErrorSelfie(`${errorRequest.error.message}`);
      setValidationAttempt(validationAttempt + 1);
    } finally {
      setLoadingFull(false);
    }
  };

  const editCardStatus = e => {
    setEditCard(e);
    if (editCard) {
      setCardTouched(false);
      setInputsDisabled(false);
      setShowIndentityValidator(true);
    }
  };

  const fetchConfig = async () => {
    try {
      const response = await Axios.get(`${config.api.url}/configuraciones`);
      setTermsAndConditions(get(response, 'data[0].terminosCondiciones', ''));
      setIdentityValidationAttempts(
        get(response, 'data[0].intentosValidacionIdentidad', ''),
      );
    } catch (error) {
      console.error(error);
    }
  };

  const fetchData = async () => {
    try {
      const response = await Axios.post(
        `${config.api.url}/prestamosPersonales/busqueda-por-token`,
        { token },
        {
          params: {},
        },
      );
      setTokenNubarium(response.data.tokenNubarium);

      setPrestamo(response.data);
      setDistribuidora(response.data.distribuidora);
      setProspecto(response.data.distribuidora.prospecto);
      if (!isEmpty(response.data.distribuidora.prospecto.tarjetaDebito)) {
        setTarjetaDebito(
          response.data.distribuidora.prospecto.tarjetaDebito[0].numeroTarjeta,
        );
      }

      setRequiereIdentificacion(isEmpty(response.data.identificacion));

      if (!isEmpty(response.data.identificacion)) {
        setIneFrontUrl(
          find(response.data.identificacion, {
            tipo: 'credencialElectorSuperior',
          }).url,
        );

        setIneBackUrl(
          find(response.data.identificacion, {
            tipo: 'credencialElectorInferior',
          }).url,
        );
      }

      if (!get(response, 'data')) {
        setNotFound(true);
      }

      LogRocket.identify(response.data.distribuidora.id, {
        name: response.data.distribuidora.prospecto.usuario.nombreCompleto,
      });

      const voucherStatus = get(response, 'data.estatus', '');
      if (voucherStatus !== 'pendiente') {
        if (voucherStatus === 'cancelado' || voucherStatus === 'bloqueado') {
          setAlreadyUsed('Este préstamo se encuentra cancelado');
        } else if (voucherStatus === 'activo' || voucherStatus === 'cobrado') {
          setAlreadyUsed('Este préstamo ya fue canjeado.');
        } else {
          setAlreadyUsed('No se encuentra información del préstamo.');
        }
        // return;
      }
    } catch (error) {
      setNotFound(true);
      console.error(error);
    } finally {
      setLoading(false);
      setLoadingFull(false);
    }
  };

  useEffect(() => {
    if (seguroOptions.length === 1) {
      setSeguroSelected(head(seguroOptions).id);
    }
  }, [seguroOptions]);

  const b64toBlob = (b64Data, contentType = '', sliceSize = 512) => {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i += 1) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  };

  const disabled =
    buttonDisabled ||
    !termsAgreed ||
    (showIdentityValidator && !selfie) ||
    // (!inputsDisabled && card !== confirmCard) ||
    errorSelfie;

  const errorCard = cardTouched && !isCreditCard(card);

  const prepareForNubariumSDK = () => {
    setCurrentlyIdCapture(true);
    setAlreadyIdCapture(!alreadyIdCapture);
    setIneFrente('');
    setIneReverso('');
    setIneFrontUrl('');
    setIneBackUrl('');
  };

  const xoptions = {
    enableHighAccuracy: true,
    timeout: 120000,
    maximumAge: 0,
  };

  function success(pos) {
    if (pos === null) return;

    if (pos.cords === null) {
      console.log(pos);
      return;
    }

    const crd = pos.coords;
    // setLatitud(crd.latitude);
    // setLongitud(crd.longitude);
    latitudRef.current = crd.latitude;
    longitudRef.current = crd.longitude;
  }

  function xerror(err) {
    console.warn(`ERROR(${err.code}): ${err.message}`);
  }

  // NOTE: DEBUG
  // console.log({ ineFrente });
  // console.log({ ineReverso });
  // console.log({ selfie });
  // console.log({ showIdentityValidator });
  // console.log({ buttonDisabled });
  // console.log({ disabled });
  // console.log('(showIdentityValidator && !selfie)');
  // console.log(showIdentityValidator && !selfie);
  // console.log(distribuidora);
  // console.log(prospecto);
  // console.log(tarjetaDebito);
  // console.log(requiereIdentificacion);
  // console.log({ activeStep });

  return (
    <ContainerGeneral>
      <NavBarContainer>
        <Link to="/">
          <img className="logo" src="/images/logo.png" alt="ConmigoVales" />
        </Link>
      </NavBarContainer>
      {startExchange === false && (
        <>
          {loading && <Loader />}
          {!notFound && Boolean(alreadyUsed) && (
            <>
              <Content>
                <h1>¡Gracias por tu preferencia!</h1>
                <div style={{ textAlign: 'center' }}>{alreadyUsed}</div>
              </Content>
            </>
          )}
          {notFound && (
            <Content>
              <div>Este préstamo no existe o el link es incorrecto.</div>
            </Content>
          )}
          {!loading && !alreadyUsed && !notFound && (
            <>
              <Content>
                <h1>Canje Digital</h1>
                {confirmCancelVaucher === false && (
                  <>
                    <ContainerData>
                      <h3>{distribuidora.folio}</h3>
                      <div className="numbertwo">
                        {distribuidora.prospecto.usuario.nombreCompleto || ''}
                      </div>
                    </ContainerData>
                    <ContainerData>
                      <h3>Iniciarás tu confirmación de </h3>
                      <div className="number">
                        {Numeral(prestamo.importe || 0).format('$ 0,0.00')}
                      </div>
                      <h3>&nbsp;pesos</h3>
                    </ContainerData>
                    <ContainerData>
                      <h3>{`a ${prestamo.quincenas || ''} quincenas de `}</h3>
                      <div className="numbertwo">{`${Numeral(
                        prestamo?.pagoQuincenal || 0,
                      ).format('$ 0,0.00')} pesos`}</div>
                    </ContainerData>

                    <ContentButonGroup>
                      <ContentButon>
                        <Button
                          fullWidth
                          variant="contained"
                          color="primary"
                          size="large"
                          onClick={start}
                        >
                          Confirmar Préstamo
                        </Button>
                      </ContentButon>
                      <ContentButon>
                        <Button
                          fullWidth
                          variant="outlined"
                          color="primary"
                          size="large"
                          onClick={handleOpenCancelVaocuher}
                        >
                          No quiero el préstamo
                        </Button>
                      </ContentButon>
                    </ContentButonGroup>
                  </>
                )}

                {confirmCancelVaucher === true && (
                  <>
                    <div className="greeting">Préstamo cancelado</div>
                    <h2>`El préstamo ha sido cancelado exitosamente.`</h2>
                  </>
                )}

                <Dialog
                  open={cancelVaucher}
                  onClose={handleCloseCancelVaucher}
                  maxWidth="sm"
                >
                  <IconButton
                    style={{
                      position: 'absolute',
                      top: 5,
                      right: 5,
                      zIndex: 10,
                    }}
                    onClick={handleCloseCancelVaucher}
                  >
                    <CloseIcon />
                  </IconButton>
                  <ContentDialog>
                    <h1>¿Estás seguro de que no quieres el préstamo?</h1>
                    <h2>Al rechazarlo se cancelará y no podrás canjearlo</h2>
                    <ButtonGrupDialog>
                      <Button
                        color="primary"
                        onClick={handleCloseCancelVaucher}
                        style={{ textTransform: 'none', marginRight: 15 }}
                      >
                        Cancelar
                      </Button>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={handleCancelVaucher}
                        style={{ textTransform: 'none' }}
                      >
                        Aceptar
                      </Button>
                    </ButtonGrupDialog>
                  </ContentDialog>
                </Dialog>
              </Content>
            </>
          )}
        </>
      )}

      {/* NOTE: Se debe de dejar cambiar la tarjeta??? */}
      {startExchange && (
        <>
          {activeStep === 0 && editCard === false && existCard !== null ? (
            <>
              <Content>
                <h1>Tarjeta de debito</h1>

                {loading && <div>Cargando...</div>}
                {!notFound && Boolean(alreadyUsed) && (
                  <>
                    <div>{alreadyUsed}</div>
                  </>
                )}
                {notFound && (
                  <div>
                    Este préstamo no existe o el link es incorrecto. Contacte a
                    su coordinador
                  </div>
                )}

                {Boolean(valeCanjeado) && (
                  <div className="greeting">{valeCanjeado}</div>
                )}
                <div className="greeting">
                  Aquí estarías recibiendo tu prestamo
                </div>
                <ContainerCard>
                  <h2>Número de tarjeta</h2>
                  <Button
                    variant="text"
                    color="primary"
                    onClick={() => editCardStatus(true)}
                  >
                    Editar tarjeta
                  </Button>
                </ContainerCard>
                <h2
                  style={{ width: '100%' }}
                >{`**** **** **** ${lastDigits.substring(12)}`}</h2>
                <h2 style={{ width: '100%' }}>Banco</h2>
                <h2 style={{ width: '100%' }}>{myBankName}</h2>
              </Content>
            </>
          ) : null}
        </>
      )}

      {(startExchange && activeStep === 0 && editCard) ||
      (startExchange && activeStep === 0 && existCard === null) ? (
        <Content>
          {!isEmpty(tarjetaDebito) && (
            <div>
              <h1>Tarjeta de debito</h1>
              <div className="greeting">
                Tarjeta a la que sera enviada el prestamo
              </div>
              <ContainerCard>
                <h1>Ultimos digitos de la tarjeta asociada</h1>
                {/* {editCard && ( */}
                {/*   <Button */}
                {/*     variant="text" */}
                {/*     color="primary" */}
                {/*     onClick={() => editCardStatus(false)} */}
                {/*   > */}
                {/*     Cancelar */}
                {/*   </Button> */}
                {/* )} */}
              </ContainerCard>
              <h2>
                {'**** **** **** '}
                {tarjetaDebito}
              </h2>
            </div>
          )}
          {isEmpty(tarjetaDebito) && (
            <div>
              <h1>Tarjeta de debito</h1>
              <div className="greeting">
                Agregue en su aplicacion su tarjeta de debito o acuda a una
                sucursal para ello.
              </div>
              <ContainerCard>
                {/* <h1>Ultimos digitos de la tarjeta asociada</h1> */}
                {/* {editCard && ( */}
                {/*   <Button */}
                {/*     variant="text" */}
                {/*     color="primary" */}
                {/*     onClick={() => editCardStatus(false)} */}
                {/*   > */}
                {/*     Cancelar */}
                {/*   </Button> */}
                {/* )} */}
              </ContainerCard>
            </div>
          )}
        </Content>
      ) : null}

      {activeStep === 1 && (
        <Content>
          <h1>Identificación oficial</h1>
          <ContainerCard>
            <div className="greeting">
              Necesitamos el frente y reverso de su INE
            </div>
          </ContainerCard>
          {alreadyIdCaptureError && (
            <div className="greeting">
              Ha sucedido un error al momento de identificar su INE. Intentelo
              de nuevo.
            </div>
          )}
          {currentlyIdCapture && <div id="id_component"></div>}
          {currentlyIdCapture && <IdComponent />}

          {!currentlyIdCapture &&
            !ineFrente &&
            !ineReverso &&
            !ineFrontUrl &&
            !ineBackUrl && (
              <>
                <ImageContainer onClick={() => prepareForNubariumSDK()}>
                  <DocumentContainer>
                    <ImageDocumentContainer>
                      <CameraIcon color="#994878" />
                    </ImageDocumentContainer>
                  </DocumentContainer>
                </ImageContainer>
                <DocumentText>Capturar Identificación</DocumentText>
              </>
            )}
          {(ineFrente || ineFrontUrl) && !currentlyIdCapture && (
            <>
              <ImageContainer
                id={!isIOS ? 'ineFrenteDiv' : ''}
                onClick={() => prepareForNubariumSDK()}
              >
                {ineFrente ? (
                  <DocumentContainer>
                    <ImageDocumentContainer>
                      <>
                        <DistributorImage
                          alt="ineFrente.png"
                          src={`data:image/jpeg;base64,${ineFrente}`}
                        />
                      </>
                    </ImageDocumentContainer>
                  </DocumentContainer>
                ) : (
                  <DocumentContainer>
                    <ImageDocumentContainer>
                      <>
                        <DistributorImage
                          alt="ineFrente.png"
                          src={ineFrontUrl}
                        />
                      </>
                    </ImageDocumentContainer>
                  </DocumentContainer>
                )}
              </ImageContainer>
              <DocumentText>Frente</DocumentText>
            </>
          )}
          {(ineReverso || ineBackUrl) && !currentlyIdCapture && (
            <>
              <ImageContainer
                onClick={() => prepareForNubariumSDK()}
                id={!isIOS ? 'ineReversoDiv' : ''}
              >
                {ineReverso ? (
                  <DocumentContainer>
                    <ImageDocumentContainer>
                      <>
                        <DistributorImage
                          alt="ineReverso.png"
                          src={`data:image/jpeg;base64,${ineReverso}`}
                        />
                      </>
                    </ImageDocumentContainer>
                  </DocumentContainer>
                ) : (
                  <DocumentContainer>
                    <ImageDocumentContainer>
                      <>
                        <DistributorImage
                          alt="ineReverso.png"
                          src={ineBackUrl}
                        />
                      </>
                    </ImageDocumentContainer>
                  </DocumentContainer>
                )}
              </ImageContainer>
              <DocumentText>Reverso</DocumentText>
            </>
          )}
        </Content>
      )}

      {activeStep === totalSteps && !voucherRedeemed ? (
        <Content>
          <h1>Validación de identidad</h1>
          {currentlyFaceCapture && showIdentityValidator && <FaceComponent />}
          {currentlyFaceCapture && showIdentityValidator && (
            <div id="face_component"></div>
          )}

          {!currentlyFaceCapture && !selfie && (
            <>
              {showIdentityValidator ? (
                <>
                  <ImageContainer onClick={() => setCurrentlyFaceCapture(true)}>
                    <DocumentContainer>
                      <ImageDocumentContainer>
                        <CameraIcon color="#994878" />
                      </ImageDocumentContainer>
                    </DocumentContainer>
                  </ImageContainer>
                  <DocumentText>Capturar Selfie</DocumentText>
                </>
              ) : (
                <>
                  <ImageContainer onClick={() => console.log()}>
                    <DocumentContainer>
                      <ImageDocumentContainer>
                        <CheckIcon color="#994878" />
                      </ImageDocumentContainer>
                    </DocumentContainer>
                  </ImageContainer>
                  <DocumentText>Identidad validada</DocumentText>
                </>
              )}
            </>
          )}

          {!currentlyFaceCapture && selfie && (
            <>
              {errorFaceCapture ? (
                <>
                  <ImageContainer
                    onError={errorFaceCapture}
                    onClick={() => setCurrentlyFaceCapture(true)}
                  >
                    <DocumentContainer>
                      <ImageDocumentContainer>
                        <>
                          <DistributorImage
                            alt="ineFrente.png"
                            src={`data:image/jpeg;base64,${selfie}`}
                          />
                        </>
                      </ImageDocumentContainer>
                    </DocumentContainer>
                  </ImageContainer>
                  <DocumentText>{errorSelfie}</DocumentText>
                </>
              ) : (
                <>
                  <ImageContainer>
                    <DocumentContainer>
                      <ImageDocumentContainer>
                        <>
                          <DistributorImage
                            alt="ineFrente.png"
                            src={`data:image/jpeg;base64,${selfie}`}
                          />
                        </>
                      </ImageDocumentContainer>
                    </DocumentContainer>
                  </ImageContainer>
                  <DocumentText>{successSelfie}</DocumentText>
                </>
              )}
            </>
          )}

          {!currentlyFaceCapture && errorSelfie && (
            <>
              <Button
                variant="outlined"
                color="primary"
                onClick={() => setCurrentlyFaceCapture(true)}
                style={{ marginTop: 12 }}
              >
                Reintentar selfie
              </Button>
            </>
          )}

          {validationAttempt <= identityValidationAttempts && (
            <ContentTerms>
              <FormControlLabel
                control={<Checkbox name="accept" color="primary" />}
                // label="Aceptas términos y condiciones."
                className="accept-check"
                onChange={event => setTermsAgreed(event.target.checked)}
              />
              <Button onClick={handleTermsAgreedOpen}>
                Acepto términos y condiciones.
              </Button>
            </ContentTerms>
          )}

          <Snackbar
            open={Boolean(successText)}
            autoHideDuration={6000}
            onClose={() => setSuccessText('')}
          >
            <Alert onClose={() => setSuccessText('')} severity="success">
              {successText}
            </Alert>
          </Snackbar>

          {/* NOTE: Might Delete */}
          <Snackbar
            open={Boolean(errorText)}
            autoHideDuration={6000}
            onClose={() => setErrorText('')}
          >
            <Alert onClose={() => setErrorText('')} severity="error">
              {errorText}
            </Alert>
          </Snackbar>
        </Content>
      ) : null}

      {voucherRedeemed && (
        <Content>
          <h1>¡Gracias por tu preferencia!</h1>
          <div className="greeting">{`Listo, ${get(
            distribuidora,
            'prospecto.usuario.nombreCompleto',
            '',
          )}!`}</div>
          <div className="instructions">{valeCanjeado}</div>
        </Content>
      )}

      {startExchange && (
        <>
          {!voucherRedeemed && (
            <MobileStepper
              variant="dots"
              steps={totalSteps}
              activeStep={activeStep}
              nextButton={
                <>
                  {activeStep === totalSteps ? (
                    <Button
                      size="medium"
                      variant="contained"
                      color="primary"
                      onClick={() => handleConfirmarPrestamo()}
                      disabled={disabled}
                      style={{ textTransform: 'none' }}
                    >
                      Confirmar
                    </Button>
                  ) : (
                    <Button
                      size="small"
                      onClick={handleNext}
                      color="primary"
                      disabled={
                        activeStep === totalSteps ||
                        (editCard && isEmpty(card)) ||
                        (editCard && isEmpty(confirmCard)) ||
                        (editCard &&
                          activeStep === 0 &&
                          confirmCard !== card &&
                          errorCard) ||
                        (editCard && !newBank) ||
                        (editCard &&
                          activeStep === 0 &&
                          cardTouched &&
                          !isCreditCard(card)) ||
                        (editCard &&
                          activeStep === 0 &&
                          confirmCardTouched &&
                          confirmCard !== card) ||
                        isEmpty(tarjetaDebito) ||
                        (activeStep === 1 &&
                          isEmpty(ineFrente) &&
                          isEmpty(ineReverso) &&
                          isEmpty(ineFrontUrl) &&
                          isEmpty(ineBackUrl))
                      }
                      style={{ textTransform: 'none' }}
                    >
                      Siguiente
                    </Button>
                  )}
                </>
              }
              backButton={
                <Button
                  size="small"
                  onClick={handleBack}
                  color="primary"
                  disabled={activeStep === 0}
                  style={{ textTransform: 'none' }}
                >
                  Atrás
                </Button>
              }
            />
          )}
        </>
      )}

      {loadingFull && <Loader />}
      <Dialog
        open={termsAgreedOpen}
        onClose={handleTermsAgreedClose}
        maxWidth="sm"
      >
        <IconButton
          style={{ position: 'absolute', top: 16, right: 16, zIndex: 1 }}
          onClick={handleTermsAgreedClose}
        >
          <CloseIcon />
        </IconButton>
        <ContainerDialogTerms>
          <div>{parse(termsAndConditions, options)}</div>
        </ContainerDialogTerms>
      </Dialog>
    </ContainerGeneral>
  );
};

export default CanjePrestamoConfirmar;
